import { z } from 'zod';

import {
  AdditionalFiltersSchema,
  BasicFiltersSchema,
  PropertyTypeSchema,
  SortSchema,
} from '@/entities/listing/typings/api-types';

export type AccommodationDetailsSearchData = z.infer<
  typeof accommodationDetailsSearchSchema
>;

export const accommodationDetailsSearchSchema = z.object({
  ...BasicFiltersSchema.shape,
  ...AdditionalFiltersSchema.shape,
  ...SortSchema.shape,
  bookingType: z.union([
    z.literal('your-tour'),
    z.literal('accommodation'),
    z.literal('excursion'),
  ]),
  accommodationId: z.string(),
  apartmentId: z.string(),
  propertyType: PropertyTypeSchema,
});
